import _get from 'lodash/get';

export function selectAllProviderServiceSettings(state) {
  return _get(state, 'business.provider_service_settings.value', []).map((settings, index) => ({
    ...settings,
    globalIndex: index,
  }));
}
